/*
 * Allows quick custom validation for input fields. The expression provided has access the variable 'value' that is the new value of the input element
 * Example:
 *      <input type="text" ng-model="day" wow-valid-when="value >= 1 && value <= 31" />
 */
module.exports = function ($parse) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link(scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.olyValidWhen = function (modelValue, viewValue) {
                if (ngModelCtrl.$isEmpty(modelValue)) {
                    // consider empty models to be valid
                    return true;
                }

                if (attrs.olyValidWhen && $parse(attrs.olyValidWhen)({ value: modelValue || viewValue })) {
                    // it is valid
                    return true;
                }

                // it is invalid
                return false;
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/valid-when/valid-when-directive.js
 **/